import { useQuery } from '@tanstack/react-query';

import { getOrdersByIds } from '~/services/OrdersService';

export const ordersByIdsQueryKeys = {
  all: ['ordersByIds'] as const,
  lists: () => [...ordersByIdsQueryKeys.all, 'list'] as const,
  list: (orderIds: Array<string>, brand: string) => [...ordersByIdsQueryKeys.lists(), brand, orderIds] as const,
};

export function useGetOrdersByIds(orderIds: Array<string>, brand: string, enabled = true) {
  return useQuery({
    queryKey: ordersByIdsQueryKeys.list(orderIds, brand),
    queryFn: async () => getOrdersByIds(orderIds, brand),
    enabled: enabled && orderIds.length > 0 && Boolean(brand.trim()),
    staleTime: 60_000,
  });
}
